import React from 'react';
import PropTypes from 'prop-types';
import { Field } from 'react-final-form';
import { AttributeTypes } from '../../models/respondentProfileTemplates/AttributeTypes';
import FormTextField from '../form/FormTextField';
import FormSelect from '../form/FormSelect';
import { Grid } from '@material-ui/core';
import VoterApproval from './VoterApproval';

const renderItem = (item, index, readonly) => {
  switch (item.type) {
    case AttributeTypes.text:
      return (
        <Grid key={item.id} item xs={12} md={6}>
          <Field
            name={`respondentProfileValues[${index}].valueText`}
            component={FormTextField}
            label={item.name}
            placeholder={item.placeholder}
            fullWidth
            disabled={readonly}
            inputProps={{ 'aria-label': item.name }}
          />
        </Grid>);
    case AttributeTypes.selection:
      return (
        <Grid key={item.id} item xs={12} md={6}>
          <Field
            name={`respondentProfileValues[${index}].selectedOptionId`}
            component={FormSelect}
            label={item.name}
            placeholder={item.placeholder}
            values={item.options.map(option => ({ value: option.id, name: option.value }))}
            fullWidth
            disabled={readonly}
          />
        </Grid>
      );
    default:
      return null;
  }
};

const RespondentProfileSubmissionForm = ({ respondentProfile, readonly, approvals, tenantName }) => (
  <div className="row">
    <div className="box-header-outside">
      <div className="col-sm-12">
        <div className="header">
          <h2>Dane osoby głosującej</h2>
        </div>
      </div>
    </div>
    <div className="box">
      <div className="col-sm-12">
        <Grid container spacing={2} alignItems="flex-end">
          {respondentProfile.map((item, index) => renderItem(item, index, readonly))}
        </Grid>
        {approvals.privacyDataProcessingPolicyApprovalRequired
          || approvals.gdprApprovalRequired
          || approvals.termsAndConditionsApprovalRequired
          ? <VoterApproval
            respondentProfile={respondentProfile}
            privacyDataProcessingPolicyApprovalRequired={approvals.privacyDataProcessingPolicyApprovalRequired}
            gdprApprovalRequired={approvals.gdprApprovalRequired}
            termsAndConditionsApprovalRequired={approvals.termsAndConditionsApprovalRequired}
            disabled={readonly}
            tenantName={tenantName}
          />
          : null}
      </div>
    </div>
  </div>
);

RespondentProfileSubmissionForm.propTypes = {
  respondentProfile: PropTypes.array.isRequired,
  readonly: PropTypes.bool,
  approvals: PropTypes.object,
  tenantName: PropTypes.string,
};

export default RespondentProfileSubmissionForm;



// WEBPACK FOOTER //
// ./src/components/consultationSurveys/RespondentProfileSubmissionForm.js